import httpClient from "./httpClient";

export const getAll = async () => {
    return await httpClient.get(`private/sponsordashboard/getAllForUser`);
};

export const get = async (data) => {
    return await httpClient.get(`private/sponsordashboard/get/?id=${(data || {}).id}&cases=${(data || {}).cases}&uniqueLink=${(data || {}).uniqueLink}`);
};

export const add = async (data) => {
    return await httpClient.post(`private/sponsordashboard/add`, data);
}

export const remove = async (data) => {
    return await httpClient.delete(`private/sponsordashboard/remove/${data.id}`);
};

export const update = async (data) => {
    return await httpClient.put(`private/sponsordashboard/edit/`, data);
};

export const notifySponsor = async (data) => {
    return await httpClient.post(`private/sponsordashboard/notify`,data)
}

export const saveDataSponsor = async (data) => {
    return await httpClient.post(`private/sponsordashboard/updatedatasponsor`,data)
}

export const download = async () => {
    return httpClient({
        method: 'GET',
        url: "private/sponsordashboard/download",
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' },
        params: {
            data: 'nothing'
        }
    })
};